(function () {
	'use strict';

	a3_pilot_reports.controller('CalendarCtrl', CalendarCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name CalendarCtrl
    * @description 
    *   View your schedule (flights and ground duties)
    * @ngInject
    */
	function CalendarCtrl($scope, version, $location, MemoFactory, FlightFactory, UserFactory, CrewRouteFactory, 
							MessageFactory, UpdateService, SyncLogFactory, $timeout, $uibModal, GroundDutyFactory, SettingsMain, 
							defaultCalendarDate, CrewHotelFactory, TrainingSessionFactory, FlightSessionFactory, ScheduleAcknowledgeFactory, 
							TraineeCoursesDetailsFactory) {
								
		$scope.pendingOverdueReports = 0;
		$scope.draftReports = 0;
		$scope.completedReports = 0;


		$scope.isSecure = UserFactory.isSecure();
		$scope.state = 'calendar';

		if (version) {
			$scope.version = version.replace('appVersion_', '');
		} else {
			$scope.version = '';
		}

		//scope variables
		var user = UserFactory.getUser();
		$scope.logged_user_info = user.aimsId + ' - ' + user.name;
		$scope.storageUsage = storageUsage;

		//SetupView
		$scope.setupView = setupView;

		//Pages
		$scope.addFlight = addFlight;

		$scope.searchPastGroundDuties = searchPastGroundDuties;
		
		//Modals
		$scope.openSynch = openSynch;

		$scope.hasUnsetTraining = false;

		var groundSessions = [];
        var flightSessions = [];
        TrainingSessionFactory.getAll(function(savedGroundSessions){
            FlightSessionFactory.getAll(function(savedFlightSessions){
                groundSessions = savedGroundSessions;
                flightSessions = savedFlightSessions;

                $scope.setupView(false);
            });
		});


        /**
         * Setups Calendar View
         * @memberof CalendarCtrl
         * @param {boolean} isReload
         */
		function setupView(isReload) {
			if (!UserFactory.isLoggedIn()) {
				$location.path("/login");
			}

			$scope.NeedsToSync = UpdateService.updater();
			/*				
			var reportstobesynched = PilotReportLocalEditFactory.getPilotReportLocalEditThatNeedToBeSynched();
		
			$scope.number_of_reports_to_sync = reportstobesynched.length;
			*/
			$scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
			$scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();

			//Get count of unread memos but remove the ones that belong in 'Training Surveys' Category
			MemoFactory.getUnreadMemos(function (memos) {

				var unreadMemosCount = 0;
				//remove memos that belong in "Training Surveys" category
				for (var i = 0; i < memos.length; i++) {
					if (memos[i].Category != "Training Surveys") {
						unreadMemosCount++;
					}
				}
				$scope.unreadMemosCount = unreadMemosCount;
			});

			// read the flights from the local storage and display them
			var flights = FlightFactory.getFlightsFromStorageAndCheckIfTooOld();

			// also load the flights created by the user
			flights = FlightFactory.getLocalFlightsAndMergeWithServerFlights(flights);


			// if no local flights are found then force sync
			if (!isReload) {
				needsToSync = true;
			}
			var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
			var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
			var crewRoutesEvents = formatCrewRoutes(crewRoutes);

			var traineeGroundCourses = TraineeCoursesDetailsFactory.getTraineeCourses();
			var groundDutiesEvents = formatGroundDuties(groundDuties, traineeGroundCourses);
			var traineeFlightCourses = TraineeCoursesDetailsFactory.getFlightCourses();
			var flightEvents = formatFlights(flights, traineeFlightCourses);

			var events = flightEvents.concat(groundDutiesEvents).concat(crewRoutesEvents);

			var specialDates = findScheduleChangedDates();

			// //temporary disable for A3
			// var showInCalendar = CrewHotelFactory.showHotelsInCalendar(flights)
			// if(showInCalendar){
			// 	var crewHotels = CrewHotelFactory.getCrewHotelsFromStorage();
			// 	var crewHotelsEvents = formatHotels(crewHotels);
			// 	events = events.concat(crewHotelsEvents);
			// }

			//Enable again!
			var crewHotels = CrewHotelFactory.getCrewHotelsFromStorage();
			var crewHotelsEvents = formatHotels(crewHotels);
			events = events.concat(crewHotelsEvents);

			calendar(events, specialDates);

			var needsToSync = false;

			// check the last sync date
			var lastLog = SyncLogFactory.getSyncLog();
			var canShowSync = true;
			if (lastLog == null) {
				needsToSync = true;
			} else {
				canShowSync = lastLog.canShowSync(); //used to avoid showing again and again the dialog :: delay X minutes before showing again
				if (lastLog.date == null)
					needsToSync = true;
				else if (lastLog.date != null) {
					if (Date.today().add(-1).days().toUTC().isAfter(new Date(lastLog.date).toUTC()) || lastLog.forceSync) {
						if (!isReload)
							needsToSync = true;
					}
				}
			}

			var isOpenUpdateModal = ($(".modal-updating").data('bs.modal') || { isShown: false }).isShown;
			if (needsToSync && canShowSync && !isOpenUpdateModal) {
				$scope.openSynch();
			}
			else {
				MemoFactory.getMandatoryUnreadMemos(function (memos) {
					var mandatoryUnread = 0;
					//remove memos that belong in "Training Surveys" category
					for (var i = 0; i < memos.length; i++) {
						if (memos[i].Category != "Training Surveys") {
							mandatoryUnread++;
						}
					}
					$scope.mandatoryUnread = mandatoryUnread;

					if ($scope.mandatoryUnread > 0) {
						openMandatoryModal();
					}
				});
			}

		}

		function openMandatoryModal() {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/Flight/dlgMandatory.html',
				controller: 'MandatoryModalCtrl',
				size: 'md',
				backdrop: 'static',
				keyboard: false,
				resolve: { mandatoryUnread: $scope.mandatoryUnread }
			});
		}

        /**
         * Finds the dates with a change on their schedule
         * @memberof CalendarCtrl
         * @param {array} events Calendar events (Flights and Ground duties) 
         * @returm {array} scheduleChangedDates
         */
		function findScheduleChangedDates() {
            var scheduleChangedDates = ScheduleAcknowledgeFactory.getScheduleChangesFromStorage();

            return scheduleChangedDates;
        }

		

        /**
         * Initialize Calendar
         * @memberof CalendarCtrl
         * @param {array} events Flights and Ground duties 
         * @param {array} specialDates The Schedule Changed Dates
         */
		function calendar(events, specialDates) {
			
			$("#calendar").fullCalendar({

				defaultView: getDefaultView(),
				defaultDate: defaultCalendarDate,
				firstDay: 1,
				lang: 'en',
				editable: false,
				draggable: false,
				selectable: false,
				selectHelper: false,
				unselectAuto: false,
				disableResizing: false,
				droppable: false,
				fixedWeekCount: false, nextDayThreshold: "00:00:00",
				header: {
					left: 'title',
					center: '',
					right: 'month,listMonth today prev,next'
				},
				timeFormat: 'HH:mm',
				displayEventEnd: true,
				events: events,
				eventRender: function (event, element, icon) {
					if ($('#calendar').fullCalendar('getView').type === 'listMonth') {
						element.find('.fc-list-item-title').addClass('listview-icon');
						$.each(event.className, function (index, icon) {
							element.addClass(event.listViewColor);
						});
						// $.each(event.icons, function (index, icon) {
						//     element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
						// });

						if (!event.description == "") {
							element.find('.fc-list-item-title').append("<span>" + "  " + event.description + "</span>");
						}
						if (!event.icon == "") {
							element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.icon + " '></i>");
						}
						if (!event.second_icon == "") {
							element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.second_icon + " '></i>");
						}
						if(!event.third_icon == "") {
                            element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.third_icon + " '></i>");
                        }
					}
					else {

						if (event.type == "crewRoute" || event.type == "crewHotel") {
							element.find('.fc-time').remove();
						}
						element.find('.fc-title').prepend("<br/>");
						if (!event.description == "") {
							if(event.routeIndicators && event.routeIndicators.length >0){
								var routeIndicatorLetters = "";
								for (var j = 0; j < event.routeIndicators.length; j++) {
									var letter = "<strong class='pull-right " + event.routeIndicators[j].routeIndicatorColor +"'>" + event.routeIndicators[j].routeIndicatorCode +"</strong>";
									routeIndicatorLetters = routeIndicatorLetters + letter;
								}

								element.find('.fc-title').append(
									"<br/><span class='calendar-light'>" + event.description + "</span>" + 
									routeIndicatorLetters +
									"<br/>");
							}
							else{
								element.find('.fc-title').append("<br/><span class='calendar-light'>" + event.description + "</span> <br/>");

							}
						}
						if (!event.icon == "") {
							element.find('.fc-title').append("<i class='calendar-icon fa " + event.icon + " '></i>");
						}
						if (!event.second_icon == "") {
							element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.second_icon + " '></i>");
						}
						if(!event.third_icon == "") {
                            element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.third_icon + " '></i>");
                        }
					}
				},

				dayRender: function (date, cell) {
					for (var i = 0; i < specialDates.length; i++) {
						var objdate = new Date(specialDates[i]);
						if ((date._d.getFullYear() == objdate.getFullYear()) &&
							(date._d.getDate() == objdate.getDate()) &&
							(date._d.getMonth() == objdate.getMonth())
						)
							cell.addClass('bg-yellow');
					}
				},
				dayClick: function (date, jsEvent, view) {
				},
				eventClick: function (calEvent, jsEvent, view) {
					if (calEvent.type == "flight") {
						$timeout(function () {
							gotoFlightInfo(calEvent._id);
						});
					}
					else if (calEvent.type == "groundDuty") {
						$timeout(function () {
							gotoGroundDutyInfo(calEvent._id);
						});
					}
					else if (calEvent.type == "crewRoute") {
						$timeout(function () {
							gotoCrewRouteInfo(calEvent.dutyNo, calEvent.dutyDay);
						});
					}

				},
				height: 'auto'
			});


			function getDefaultView() {
				var calendarStyle = SettingsMain.getCalendarViewStyle();
				if (calendarStyle == null) {
					calendarStyle = detectMobile() ? "listMonth" : "month";
				}
				return calendarStyle;

			}

			function detectMobile() {
				var isMobile = (window.innerWidth <= 800 && window.innerHeight <= 735);

				return isMobile;
			}

			$('.fc-listMonth-button').click(function () {
				SettingsMain.setCalendarViewStyle('listMonth');
			})

			$('.fc-month-button').click(function () {
				SettingsMain.setCalendarViewStyle('month');
			})

		}
        /**
         * Transform flights in calendar events
         * @memberof CalendarCtrl
         * @param {array} flights The Scheduled Flights 
         * @return {array} events 
         */
		function formatFlights(flights, traineeFlightCourses) {
            var flightEvents = [];
         

            for (var i = 0; i < flights.length; i++) {
                var description = flights[i].getRoute();
                var title = flights[i].FlightNo;
                var third_icon ="";
                var flightCourseStatuses = [];
                var flightCoursesFlat = [];
                if (flights[i].TrainingIndicatorCode) {
                    title = title + " " + flights[i].TrainingIndicatorCode;
                }

                /* Trainee flight courses */
           
                var relatedFlightTraineeCourses = [];
                for (var j = 0; j < traineeFlightCourses.length; j++){
                    if(flights[i].IsTrainee == true && flights[i].FlightId == traineeFlightCourses[j].FlightId) {
                        relatedFlightTraineeCourses = traineeFlightCourses.find(x => x.FlightId == flights[i].FlightId);
                                  
                        flightCoursesFlat = flightCoursesFlat.concat(relatedFlightTraineeCourses);
                   
                   
                    /*  NotSet = 0,
                        InProgress = 1,
                        Completed = 2,
                        Pending = 3,
                        NeedsApproval = 4,
                        NotCompleted = 5 
                    */
                    }
                 
                    if(flightCoursesFlat.length > 0){
                        console.log(relatedFlightTraineeCourses);
                        console.log(flightCourseStatuses);
                    }
                    
                }
               if (flightCoursesFlat.length > 0) {
                flightCoursesFlat.forEach(function (x) {
                    flightCourseStatuses.push(x.Status);
                  
                });
               }
          
                if (flightCourseStatuses.includes(1)) {
                    //Pending
                    third_icon = "fa-graduation-cap text-blue";
                } else if (flightCourseStatuses.includes(2)) {
                    //Completed
                    third_icon = "fa-graduation-cap text-green";
                }  else if (flightCourseStatuses.includes(4) || flightCourseStatuses.includes(5))  {
                    //Needs approval or stopped
                    third_icon = "fa-graduation-cap text-orange";
                }

                var classname = "";
                var icon = "fa-plane";
                var second_icon = "";
                var id = flights[i].FlightId;
                var type = "flight";
                var listViewColor = "";

                /*              Weights for status of reports
                                6 --> na
                                5 --> draft
                                4 --> pendingoverdue
                                3 --> pending
                                2 --> completed
                                1 --> synched */

                var CabinReportStatusWeight = 0;
                if (flights[i].LineStatus === 'na')
                    CabinReportStatusWeight = 6;
                else if (flights[i].LineStatus === 'pending')
                    CabinReportStatusWeight = 3;
                else if (flights[i].LineStatus === 'pendingoverdue') {
                    CabinReportStatusWeight = 4;
                    $scope.pendingOverdueReports++;
                } else if (
                    (flights[i].LineStatus === 'draft') ||
                    (flights[i].LineStatus === 'draftotheruser')
                ) {
                    $scope.draftReports++;
                    CabinReportStatusWeight = 5;
                } else if (
                    (flights[i].LineStatus === 'completed') ||
                    (flights[i].LineStatus === 'completedotheruser')
                ) {
                    $scope.completedReports++;
                    CabinReportStatusWeight = 2;
                } else if (
                    (flights[i].LineStatus === 'stored') ||
                    (flights[i].LineStatus === 'storedotheruser') ||
                    (flights[i].LineStatus === 'stored+otheruser') ||
                    (flights[i].LineStatus === 'synched') ||
                    (flights[i].LineStatus === 'synchedotheruser')
                ) {
                    CabinReportStatusWeight = 1;
                }
                //Remove Assessment Weight For Coloring
                /*    var AssessmentStatusWeight = 0;
                    if (isAssessmentEnabled && flights[i].assessment){
                        if(flights[i].assessment.IsExist || flights[i].assessment.Status == 'Stored'){
                            AssessmentStatusWeight = 1
                        }else if(flights[i].assessment.Status == 'Completed'){
                            AssessmentStatusWeight = 2;
                        }else if(flights[i].assessment.Status == 'Pending'){
                            AssessmentStatusWeight = 3;
                        }else if(flights[i].assessment.Status == 'Draft'){
                            AssessmentStatusWeight = 5;
                        }
                    }*/

                var statusWeight = CabinReportStatusWeight;
                // var statusWeight = CabinReportStatusWeight > AssessmentStatusWeight ? CabinReportStatusWeight : AssessmentStatusWeight;

                if (statusWeight == 6) {
					if (flights[i].IsDHC) {
                        classname = "fc-aluminum";
                        icon = "";
                        listViewColor = "lv-aluminium";
                    } else{
                        classname = "fc-white";
                        icon = "";
                        listViewColor = "lv-white";
                    }
                } else if (statusWeight == 5) {
                    classname = "fc-orange";
                    icon = "fa-pencil";
                    listViewColor = "lv-orange";
                } else if (statusWeight == 4) {
                    classname = "fc-seablue";
                    icon = "fa-exclamation-triangle text-lemon";
                    listViewColor = "lv-seablue";
                } else if (statusWeight == 3) {
                    classname = "fc-blue";
                    icon = "fa-plus";
                    listViewColor = "lv-blue";
                } else if (statusWeight == 2) {
                    classname = "fc-purple";
                    icon = "fa-check-circle";
                    listViewColor = "lv-purple";
                } else if (statusWeight == 1) {
                    classname = "fc-green";
                    icon = "fa-cloud-download";
                    listViewColor = "lv-green";
                }

                if (flights[i].IsScheduleChanged && flights[i].LineStatus != 'na') {
                    classname = classname + " text-yellow-important";
                }

                if (
                    (flights[i].LineStatus === 'draftotheruser') ||
                    (flights[i].LineStatus === 'completedotheruser') ||
                    (flights[i].LineStatus === 'synchedotheruser') ||
                    (flights[i].LineStatus === 'storedotheruser') ||
                    (flights[i].LineStatus === 'stored+otheruser')
                )
                    second_icon = "fa-user";

                var IsScheduleChanged = flights[i].IsScheduleChanged;
                var ScheduledDeparture = flights[i].ScheduledDeparture

                if (flights[i].ScheduledArrival == null) {
                    var ScheduledArrival = ScheduledDeparture;
                } else {
                    var ScheduledArrival = flights[i].ScheduledArrival
                }

                var event = {
                    _id: id,
                    title: title,
                    start: ScheduledDeparture,
                    end: ScheduledArrival,
                    description: description,
                    icon: icon,
                    second_icon: second_icon,
                    className: classname,
                    type: type,
                    isScheduleChanged: IsScheduleChanged,
                    listViewColor: listViewColor,
                    third_icon: third_icon
                };
                flightEvents.push(event)
            }
            return flightEvents;
        }

        /**
         * Transform Ground Duties in calendar events
         * @memberof CalendarCtrl
         * @param {array} duties The Scheduled Ground Duties 
         * @return {array} events 
         */
		function formatGroundDuties(duties, traineeGroundCourses) {
			var groundEvents = [];
			var now=moment.utc();

			for (var i = 0; i < duties.length; i++) {
				//var description = duties[i].DutyDescription +"<br/>";
				var description = duties[i].Code;
				var title = (duties[i].Title) ? duties[i].Title : duties[i].Duty;


				var classname = "fc-white";
				var icon = "";
				if(duties[i].RelatedGroundDuties && duties[i].RelatedGroundDuties.length > 1){
					icon="fa-graduation-cap" // icon only if training
					
					//Get ground courses
					var courseStatuses =[]; 
					var coursesFlat = [];
					for(var j=0; j<duties[i].RelatedGroundDuties.length; j++){
						 /* Trainee ground courses */
						 if(traineeGroundCourses.length > 0){
                            var relatedTraineeCourse = traineeGroundCourses.find(x => x.GroundDutyId == duties[i].Id);
                        }

						var relatedDutyCourse = duties[i].RelatedGroundDuties[j].Courses;
						if(relatedDutyCourse){
							coursesFlat = coursesFlat.concat(relatedDutyCourse);
						}

						if (relatedTraineeCourse) {
                            coursesFlat = coursesFlat.concat(relatedTraineeCourse);
                        }
					}

					coursesFlat.forEach(function(x){
						courseStatuses.push(x.Status)
					});

					/*Statuses
						Completed : session has been sent
						Outdated  :	session submission is overdue
						Draft	  : session completion has started but not submitted
						Pending   : session submission not yet due
					*/
					 /*  NotSet = 0,
                        InProgress = 1,
                        Completed = 2,
                        Pending = 3,
                        NeedsApproval = 4,
                        NotCompleted = 5 
                    */
					if(courseStatuses.includes("Pending") || courseStatuses.includes(1)){

						//Pending
						classname = "fc-blue-inverted"
						
						//Outdated
						var dutyEnd = moment.utc(duties[i].DutyEnd);
						var duration = moment.duration(now.diff(dutyEnd)).asHours();
						if(duration>1){
							if(courseStatuses.includes("Pending"))	$scope.hasUnsetTraining = true;
							classname = "fc-seablue-inverted"
							icon = "fa-exclamation-triangle text-yellow";
						}

						//Draft
						var courseId = coursesFlat[0].CourseId; // each duty should contain ONLY ONE COURSE
						var duty = duties[i];

						if(groundSessions && groundSessions.length){
							var existingSession = groundSessions.find(s => s.courseId == courseId && s.day == duty.DutyDateS && s.dutyId == duty.Id);
							if(existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length){
								//a training session with trainees exists
								classname = "fc-orange-inverted";
								icon = "fa-graduation-cap";
							}
						}
					}else if(courseStatuses.includes("Completed") || courseStatuses.includes(2)){
						//Completed
						classname = "fc-green-inverted "
					}
					else if(courseStatuses.includes(4) || courseStatuses.includes(5)) {
                        //Needs approval or stopped
                        classname = "fc-orange-inverted";
                    }
				}
				
				var second_icon = "";
				if (duties[i].Unread) {
					second_icon = "fa-envelope text-orange";
				}

				var id = duties[i].Id;
				var type = "groundDuty";
				var start = (duties[i].DutyBegin) ? duties[i].DutyBegin : ((duties[i].DutyDateS) ? duties[i].DutyDateS : duties[i].DutyDate);
				var end = duties[i].DutyEnd;
				var listViewColor = "lv-white";


				var event = {
					_id: id,
					title: title,
					start: start,
					end: end,
					description: description,
					icon: icon,
					second_icon: second_icon,
					className: classname,
					type: type,
					listViewColor: listViewColor
				};

				groundEvents.push(event);
			}

			return groundEvents;
		}

		/**
         * Transform Crew Routes in calendar events
         * @memberof CalendarCtrl
         * @param {array} routes The Scheduled Crew Routes 
         * @return {array} events 
         */
		function formatCrewRoutes(routes) {
			var crewRouteEvents = [];
            var now=moment.utc();

			for (var i = 0; i < routes.length; i++) {
				var description = routes[i].Route;
				// var title = (duties[i].Title)? duties[i].Title : duties[i].Duty;

				var classname = "fc-white";

				var icon = "";
				var second_icon = "";

				//Get ground courses
				var courseStatuses=[]; 
				var courses = routes[i].Courses;

				if(courses){
					courses.forEach(function(x){
						courseStatuses.push(x.Status)
					});
				}

				/*Statuses
					Completed : session has been sent
					Outdated  :	session submission is overdue
					Draft	  : session completion has started but not submitted
					Pending   : session submission not yet due
				*/

				var trainingStatus = "";
				if(courseStatuses.includes("Pending")){
					//Pending
					trainingStatus = "Pending";

					//Outdated
					var dutyEnd = moment.utc(routes[i].DutyEnd);
					var duration = moment.duration(now.diff(dutyEnd)).asHours();
					if(duration>1){
						if(courseStatuses.includes("Pending"))	$scope.hasUnsetTraining = true;
						trainingStatus = "Outdated";
					}

					//Draft
					var courseIds = courses.map(x => x.CourseId); 
					var route = routes[i];

					if(flightSessions && flightSessions.length > 0){
						//TODO msis fix
						var dutyBegin =  new moment(route.DutyBegin).format("YYYY-MM-DD");
						var dutyEnd =  new moment(route.DutyEnd).format("YYYY-MM-DD");
						//TODO:: fix null.courseId
						var existingSessions = flightSessions.filter(s => s != null && courseIds.includes(s.courseId) && (new moment(s.day).isSame(dutyBegin) || new moment(s.day).isSame(dutyEnd) || new moment(s.day).isBetween(dutyBegin, dutyEnd)) 
																			&& s.dutyDay == route.DutyDay && s.dutyNo == route.DutyNo);
						if(existingSessions && existingSessions.some(x => !x.HasLimitedInfo && x.trainees && x.trainees.length)){
							//a training session with trainees exists
							trainingStatus = "Draft";
						}
					}
				}else if(courseStatuses.includes("Completed")){
					//Completed
					trainingStatus = "Completed";
					classname = "fc-green-inverted ";
				}


				if(trainingStatus == "Outdated"){
					second_icon = "fa-exclamation-triangle text-yellow second-icon-training";
					classname = "fc-seablue-inverted";
				}
				else if(trainingStatus == "Draft"){
					classname = "fc-orange-inverted";
				}
				else if(trainingStatus == "Pending"){
					classname = "fc-blue-inverted";
				}
				else if (trainingStatus == "Completed"){
					classname = "fc-green-inverted";
				}

				if(courses && courses.length){
                    icon = "fa-graduation-cap";
				}

				var routeIndicators = [];
				if(routes[i].RouteIndicators){
				// Swap : [RECTYPE] = 106
                // Pre-Assigned : [RECTYPE] = 1
                // Requested : [RECTYPE] = 100
                // Unfinalised : [RECTYPE] = 101
                var routeIndicatorCodes = routes[i].RouteIndicators.split(',').map(Number);
                    for (var j = 0; j < routeIndicatorCodes.length; j++) {
                        var routeIndicatorCode = "";
                        var routeIndicatorColor= "";
        
                        if(routeIndicatorCodes[j]){
        
                            if(routeIndicatorCodes[j] == 106){
                                routeIndicatorCode = "S";
                                routeIndicatorColor = "text-purple";
                            }
                            else if(routeIndicatorCodes[j] == 1){
                                routeIndicatorCode = "P";
                                routeIndicatorColor = "text-teal";
                            }
                            else if(routeIndicatorCodes[j] == 100){
                                routeIndicatorCode = "R";
                            }
                            else if(routeIndicatorCodes[j] == 101){
                                routeIndicatorCode = "U";
								routeIndicatorColor = "text-red";
                            }
                            if( routeIndicatorCode.length >0){
                                routeIndicators.push({routeIndicatorCode:routeIndicatorCode, routeIndicatorColor: routeIndicatorColor})
                            }
                        }
                    }
				}
				

				// var id = routes[i].Id;
				var type = "crewRoute";
				var dutyNo = routes[i].DutyNo;
				var dutyDay = routes[i].DutyDay;
				var start = (routes[i].DutyBegin) ? routes[i].DutyBegin : ((routes[i].DutyDateS) ? routes[i].DutyDateS : routes[i].DutyDate);
				var end = routes[i].DutyEnd;
				var listViewColor = "lv-white";

				var event = {
					// _id:id,
					// title: title,
					dutyNo: dutyNo,
					dutyDay: dutyDay,
					start: start,
					end: end,
					description: description,
					icon: icon,
					second_icon: second_icon,
					className: classname,
					type: type,
					listViewColor: listViewColor,
					routeIndicators: routeIndicators
				};

				crewRouteEvents.push(event);
			}
			return crewRouteEvents;
		}

    /**
         * Transform Crew Hotels in calendar events
         * @memberof CalendarCtrl
         * @param {array} crew hotels 
         * @return {array} events 
         */
        function formatHotels(hotels, flights, groundDuties){
            var crewRouteEvents = [];
            for(var i=0;i<hotels.length;i++){
                var title = hotels[i].HotelName;
                var classname = "fc-gray-inverted";
                var icon="fa-bed";
                var second_icon="";
                var type = "crewHotel";
                var start = moment(hotels[i].DutyDate).endOf('day').toJSON();
                var listViewColor = "lv-white";
 
                var event = {
                    title: title,
                    start: start, 
                    end:   start,
                    icon:icon,
                    second_icon:second_icon,
                    className:classname,
                    type:type,
                    listViewColor: listViewColor
                };

                crewRouteEvents.push(event);
            }
            return crewRouteEvents;
        }



		//Modal functions
        /**
         * Open Synch Modal
         * @memberof CalendarCtrl
         */

		function openSynch() {
			//store last time the sync dialog was displayed
			SyncLogFactory.setLastShow();
            openSynchModal();
		}

		function openSynchModal() {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/Dialogs/dlgSynch.html',
				controller: 'SynchCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false
			});

			modalInstance.result.then(function (synchresult) {
				//refresh the view after a successful sync
				if (!synchresult == 'cancel') {
					$scope.setupView(true);
				}
			}, function () { });

		}
       


        /**
         * Open the "Add a flight" Modal
         * @memberof CalendarCtrl
         */
		function addFlight() {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/Dialogs/dlgAddFlight.html',
				controller: 'AddFlightCtrl',
				size: 'lg',
				backdrop: 'static',
				keyboard: false
			});
		}

		/**
		 * Open the "Search Ground Duties" Modal
		 * @memberof CalendarCtrl
		 */
		function searchPastGroundDuties() {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/Dialogs/dlgSearchGroundDuties.html',
				controller: 'SearchPastGDCtrl',
				size: 'md',
				backdrop: 'static',
				keyboard: false
			});
		}


        /**
         * Redirect to flight Info
         * @memberof CalendarCtrl
         */
		function gotoFlightInfo(FlightId) {
			$location.path('/flightinfo/' + FlightId);
		}

        /**
         * Redirect to groundDuty Info
         * @memberof CalendarCtrl
         */
		function gotoGroundDutyInfo(GroundDutyId) {
			$location.path('/groundDuty/' + GroundDutyId);
		}

		/**
         * Redirect to crewRoute Info
         * @memberof CalendarCtrl
         */
		function gotoCrewRouteInfo(dutyNo, dutyDay) {
			$location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
		}

        /**
         * Calculates the local storage Usage
         * @memberof CalendarCtrl
         * @return {string} usage
         */
		function storageUsage() {
			var usage = localStorageMD5Service.usedSize();
			return usage;
		}

	}


})();   